import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import type { Playlist } from '../../types';

export default function Playlists() {
  const [playlists, setPlaylists] = useState<Playlist[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPlaylists = async () => {
      const { data } = await supabase
        .from('playlists')
        .select('*')
        .eq('is_active', true)
        .order('created_at', { ascending: false });
      setPlaylists(data || []);
      setLoading(false);
    };
    fetchPlaylists();
  }, []);

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold text-white">Música de Adoración</h1>

      {loading ? (
        <div className="text-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-4 border-primary border-t-transparent mx-auto"></div>
        </div>
      ) : playlists.length === 0 ? (
        <div className="card text-center py-8">
          <p className="text-[#8E8E93]">No hay playlists disponibles</p>
        </div>
      ) : (
        <div className="space-y-3">
          {playlists.map((playlist) => (
            <Link
              key={playlist.id}
              to={`/music/${playlist.id}`}
              className="card flex items-center gap-4 "
            >
              {playlist.cover_url ? (
                <img src={playlist.cover_url} alt={playlist.name} className="w-16 h-16 rounded-lg object-cover" />
              ) : (
                <div className="w-16 h-16 bg-primary/10 rounded-lg flex items-center justify-center">
                  <span className="text-2xl">🎵</span>
                </div>
              )}
              <div className="flex-1">
                <h3 className="font-semibold text-white">{playlist.name}</h3>
                {playlist.description && (
                  <p className="text-sm text-[#8E8E93] line-clamp-1">{playlist.description}</p>
                )}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
